import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-form-buttons',
  templateUrl: './form-buttons.component.html'
})
export class FormButtonsComponent {
  @Input() isSubmitDisabled = false;
  @Input() submitBtnTranslationKey?: string | undefined;

  @Output() cancelClick: EventEmitter<void> = new EventEmitter<void>();

  public onCancelClick(): void {
    this.cancelClick.emit();
  }
}
